// The snippets the "Example" dropdown offers, in menu order. The first one
// is what the editor opens on.
//
// Each is a standalone program rather than a module: the playground checks
// one buffer with no filesystem behind it (see README.md), so nothing here
// can `require` anything else. Keep them short enough to read without
// scrolling the editor, and end each with a "try breaking it" line — the
// point of a playground is the diagnostic you get for editing it, not the
// clean check you get for leaving it alone.
//
// Examples use the current LuaJIT browser compiler. Guest FFI types are available;
// browser services use their explicit host adapters.
import TOUR from "./examples/tour.nupp";
import NARROWING from "./examples/narrowing.nupp";
import GENERICS from "./examples/generics.nupp";
import RECORDS from "./examples/records.nupp";
import UNIONS from "./examples/unions.nupp";
import CONSTRAINED from "./examples/constrained.nupp";
import OWNERSHIP from "./examples/ownership.nupp";
import SYNTAX from "./examples/syntax.nupp";
import OPTIMIZER from "./examples/optimizer.nupp";
import U32_XOR from "./examples/u32-xor.nupp";
import COMPTIME from "./examples/comptime.nupp";
import CUSTOM_DERIVE from "./examples/custom-derive.nupp";
import TYPE_LEVEL_DSL from "./examples/type-level-dsl.nupp";
import BROWSER_PLATFORM from "./examples/browser-platform.nupp";

// Roughly in order of how much of the language each one asks you to already
// know, since a menu is read top to bottom.
export const EXAMPLES = [
  { id: "tour", label: "A quick tour", source: TOUR },
  { id: "narrowing", label: "Narrowing and predicates", source: NARROWING },
  { id: "generics", label: "Generics and bounds", source: GENERICS },
  { id: "records", label: "Records and interfaces", source: RECORDS },
  { id: "unions", label: "Literal and tagged unions", source: UNIONS },
  { id: "constrained", label: "Constrained types", source: CONSTRAINED },
  { id: "ownership", label: "Ownership", source: OWNERSHIP },
  { id: "syntax", label: "LuaJIT 3.0 syntax", source: SYNTAX },
  { id: "optimizer", label: "Optimizing compiler", source: OPTIMIZER },
  { id: "u32-xor", label: "Unsigned words", source: U32_XOR },
  { id: "comptime", label: "Compile-time evaluation", source: COMPTIME },
  { id: "custom-derive", label: "Defining a custom derive", source: CUSTOM_DERIVE },
  {
    id: "type-level-dsl",
    label: "Binary type DSL",
    source: TYPE_LEVEL_DSL,
  },
  { id: "browser-platform", label: "Browser APIs", source: BROWSER_PLATFORM },
];
